/*
 * @Description: 执行计划 api
 * @Date: 2020-07-22 18:12:23
 * @LastEditTime: 2020-07-22 18:17:07
 */ 

import request from '@/utils/request.js'

export function planList(params) {
    return request({
        url: '/api/channel/plan/',
        method: 'get',
        params
    })
}

export function planDetail(params) {
    return request({
        url: `/api/channel/plan/${params.id}`,
        method: 'get',
        params
    })
}

export function planUpdate(data) {
    return request({
        url: `/api/channel/plan/${data.id}/`,
        method: 'put',
        data
    })
}

export function planDelete(data) {
    return request({
        url: `/api/channel/plan/${data.id}`,
        method: 'delete'
    })
}
